import axios from "axios";
import qs from 'qs'
import $store from "../store"

// let baseUrl = process.env.VUE_APP_BASE_URL
// let baseUrl =  'http://114.132.233.212:8077'  //生产环境api地址
let baseUrl =  'https://haidongapi.sanshierli-culture.cn'
// let baseUrl = 'http://127.0.0.1:8000'
let baseAPIUrl = baseUrl + '/'

let imageUrl = baseUrl + '/'
axios.defaults.timeout = 50000
axios.defaults.baseURL = baseAPIUrl
axios.defaults.withCredentials = false

let loading
export const request = (url, method="get", params = {}) => {
    return new Promise((resolve, reject) => {
        let token = $store.state.token
        let timeout = 100,
            rqType = 0
        setTimeout(function () {
            let method1 = method,
                headers = {
                    'Authorization': token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            axios.request({
                method: method1.toLocaleUpperCase(), 
                url: url, 
                data:qs.stringify(params),
                headers: headers
            })
            .then(response => {
                // console.log('response', response)
                if(response.data.code == 200){
                    // console.log('success')
                    resolve(response.data)
                }
                else{
                    // console.log('error')
                    resolve(false)
                }
            }, 
            err=>{
                reject(err)
            })
            .catch(res=>{
                console.log(res)
            }).finally(res=>{
            })
        }, timeout)
    })
}

export class Http{
	get(url, data={}) {
		return request(url, 'get', data)
	}
	post(url, data={}) {
		return request(url, 'post', data)
	}
	delete(url, data={}) {
		return request(url, 'delete', data)
	}
	put(url, data={}) {
		return request(url, 'put', data)
	}
	upload(url, data={}) {
        return uploads(url, data)
	}
	down(url, data={}) {
		return request(url, 'down', data)
	}
	apiurl(){
		return baseAPIUrl
	}
    imgurl(){
        return imageUrl
    }
}

export function uploads(url, params = {}){
    return new Promise((resolve, reject) => {
        let token = $store.state.token
        axios.defaults.headers['Authorization'] = token  //token放在此处意味着可以实时读取最新的
        axios.defaults.headers['Content-Type'] = 'multipart/form-data'
        let timeout = 10
        setTimeout(function () {
            axios.post(url, params).then(response => {
                if(response.data.success){
                    resolve(response.data)
                }
                else{
                    resolve(false)
                }
            }, 
            err=>{
                reject(err)
            })
        }, timeout)
    })
}

export function fileUrlTrans(url) {
    /**
     * 图片地址解析
     */
    if(url === undefined || url === '' || url === null){
        url = '/imgs/logo_df_pk.png'
    }
    else {
        if (url.indexOf('http') === -1)
            url = baseUrl + '/' + url
    }
    return url
}

export function api_url(){
    return {
        baseAPIUrl: baseAPIUrl,
        imageUrl: imageUrl,

    }
}